import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const Logo = (props) => {
    const staticBase = 'https://www.mlbstatic.com';
    const baseUrl = `${staticBase}/mlb.com/builds/site-core/6105139ccce70320c674a1c11cbdf1e9d88bfe14_1532366495`;
    const classes = classNames('p-logo', 'lazyload', props.className, ({[`p-logo--${props.size}`]: true}));
    const logoAttributes = {
        [`${props.lazyload ? 'data-' : ''}src`]: `${props.siteAssetsUri || baseUrl}/images/logos/${props.logoSet}/${
            props.id
        }.svg`,
        alt: props.altText || '',
        className: classes
    };
    if (props.logoSet === 'team-cap-on-light') {
        return (
            <img
                alt={props.altText || null}
                className={classes}
                data-src={`${staticBase}/team-logos/${props.id}.svg`}
            />
        );
    } else {
        return <img {...logoAttributes} />;
    }
};

Logo.propTypes = {
    altText: PropTypes.string,
    lazyload: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    logoSet: PropTypes.oneOf([
        'product-on-dark',
        'product-on-light',
        'team-cap-on-dark',
        'team-cap-on-light',
        'team-primary-on-dark',
        'team-primary-on-light',
        'team-wordmark-on-dark',
        'team-wordmark-on-light',
        'appstore',
        'league-on-light'
    ]).isRequired,
    siteAssetsUri: PropTypes.string
};

Logo.defaultProps = {
    logoSet: 'team-cap-on-light',
    size: 'lg',
    lazyload: true,
    altText: '',
    className: undefined,
    siteAssetsUri: undefined
};

export default Logo;
